import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.js';

const ADMIN_EMAIL = 'ccrane2@alumni.nd.edu';

export default function DevIndex() {
  const { currentUser, authLoaded } = useAuth();

  if (!authLoaded) return <p>Loading…</p>;
  if (currentUser?.email !== ADMIN_EMAIL) return <Navigate to="/" replace />;

  return (
    <div className="panel w-100">
      <h2 className="section-title mb-3">Dev (dev only)</h2>
      <ul>
        <li>
          <Link to="/dev/board-playground">Board Playground</Link> -- randomized board states for checking rendering.
        </li>
        <li>
          <Link to="/dev/design">Design</Link> -- direct links to specific board states for iterating on UI design.
        </li>
        <li>
          <Link to="/dev/practice-game">Practice Game</Link> -- play a full game against a moderate-skill computer
          opponent.
        </li>
        <li>
          <Link to="/dev/game-review">Game Review</Link> -- step through a real online game's recorded moves
          to investigate a reported bug.
        </li>
      </ul>
    </div>
  );
}
